import FieldFactory from './FieldFactory.js'

const orderField = /^(.+)[\s]+(asc|desc|ASC|DESC)$/

export default {
  id : 'Expression.FieldParser.OrderField',
  type : 'orderField',
  sort : 9999,
  handles : ( field, context ) => {
    if ( field.type !== 'ExpressionParser.Field' ) {
      return false
    }

    return field.value?.match( orderField )
  },
  parse : async ( field, context ) => {
    const matches = field.value.match( orderField )
    let [ , value, order ] = matches
    value = await FieldFactory.create( value, context )
    order = order?.trim()

    return {
      type : 'ExpressionField.order',
      value : value.fields[0],
      order : order || 'ASC'
    }
  }
}
